module.exports = __webpack_public_path__ + "static/img/lineup_cmt_j_cherry.ccf9755.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/lineup_cmt_j_cherry.svg
// module id = X0pB
// module chunks = 1